<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="assign-licenses" appLifecycleTracker trackerName="assign-fde-licenses">
    <div class="table-header">
        <h2 class="table-title">
            <button mat-mini-fab color="primary" routerLink="/products" id="fde-back-button"
                    aria-label="Go back to products page." [ngStyle]="{transform: 'scale(0.7)'}">
                <span class="mdi mdi-arrow-left left-icon"></span>
            </button>
            <span>{{'assign-fde.title' | translate}}</span>
        </h2>
        <div class="buttons-wrapper">
            @if (isMSP(user$ | async) || isCustomer(user$ | async)) {
                <button id="add-workstation-button" type="button" (click)="showAddWorkstationDialog()"
                        color="primary" mat-raised-button><span class="mdi mdi-desktop-classic icon-button"></span>
                    {{'assign.fde.add-workstation-button-title' | translate}}...
                </button>
            }
            <button id="enter-fde-request-button" type="button" (click)="showFdeRequestCodeDialog()"
                    color="primary" mat-raised-button><span class="mdi mdi-form-select icon-button"></span>
                {{ 'assign.fde.generate-fde-license-button' | translate }}...
            </button>
            @if (isMSP(user$ | async)) {
                <button mat-raised-button [matMenuTriggerFor]="actionMenu"
                        color="accent" role="link" [disabled]="licenseSelection.selected.length === 0">
                    Actions
                    <mat-icon>expand_more</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                    <button id="generate" [disabled]="licenseSelection.selected.length === 0"
                            type="button" (click)="showGenerateDialog()" mat-menu-item>
                        <mat-icon class="mdi mdi-key"></mat-icon>
                        <span>{{'assign.generate.title' | translate }}...</span>
                    </button>
                    <button id="delete-serial" type="button" (click)="showDeleteWorkstationDialog()" mat-menu-item
                            matTooltip="{{'assign.fde.actions-menu.delete-serial' | translate}}" matTooltipPosition="left"
                            [matTooltipDisabled]="!deleteSerialDisabled" [disabled]="deleteSerialDisabled">
                        <mat-icon class="mdi mdi-trash-can-outline"></mat-icon>
                        <span>{{'assign-fde.delete-button' | translate}}...</span>
                    </button>
                </mat-menu>
            }
        </div>
    </div>

    <div class="table-panel">
        <div class="assigned-count">
          @if (isLoading$ | async) {
            <ngx-skeleton-loader
                appearance="line"
                [theme]="{
                    display: 'flex',
                    height: '20px',
                    width: '200px',
                    marginBottom: '0'
                }">
            </ngx-skeleton-loader>
          }  @else {
            {{ 'assign.assigned_count' | translate : {licenses_used: (totalLicensed$ | async) | number, licenses_available: (subscriptionCount$ | async) | number} }}
          }
        </div>

        <div class="cigent-box">
            <div style="min-width: 250px;">
                <div id="total-fde-licenses" class="license-total">
                  @if (isLoading$ | async) {
                    <ngx-skeleton-loader
                            appearance="line"
                            [theme]="{
                            display: 'flex',
                            height: '20px',
                            width: '240px',
                            margin: '0 5px'
                        }">
                    </ngx-skeleton-loader>
                  }  @else {
                    <b>{{ (totalFiltered$ | async) | number }} {{ 'assign.fde.count_label' | translate }}</b>
                    &nbsp;({{'assign.shown-selected' | translate : {total: (licenses$ | async)?.length | number, selected: licenseSelection.selected.length} }})
                  }
                </div>
            </div>
            <div>
                <mat-button-toggle-group [value]="null" appearance="standard" hideSingleSelectionIndicator="true"
                                         (change)="onAssignFilterChanged($event)">
                    <mat-button-toggle [value]="null">All</mat-button-toggle>
                    <mat-button-toggle [value]="true">Assigned</mat-button-toggle>
                    <mat-button-toggle [value]="false">Unassigned</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <div style="min-width: 250px; display:flex;  justify-content: flex-end;">
                <app-column-chooser saveId="fde-column-chooser" [elements]="columns" (change)="columnsToDisplay = $event">
                </app-column-chooser>
            </div>
        </div>

        <div class="table-container" id="fde-licenses-table" #tableContainer
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="150"
            (scrolled)="onScrollHandler()"
            [alwaysCallback]="forceCallback"
            [scrollWindow]="false">
            <table mat-table [dataSource]="(isLoading$ | async) ? loadingSkeletonRows : (licenses$ | async)"
                   matSort matSortDisableClear='true'
                   [matSortActive]="sortAttr" [matSortStart]="'desc'" [matSortDirection]="sortDir"
                   (matSortChange)="onSortChange($event)" aria-label="Assigned license details">

                @if (isMSP(user$ | async)) {
                    <ng-container matColumnDef="select">
                        <th scope="col" mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                          [checked]="licenseSelection.hasValue() && isAllSelected()"
                                          [disabled]="(isLoading$ | async)"
                                          [indeterminate]="licenseSelection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let fdeLicense; let i = index">
                            <mat-checkbox (click)="onCheckboxClick($event, fdeLicense, i)"
                                          [disabled]="(isLoading$ | async)"
                                          [checked]="licenseSelection.isSelected(fdeLicense)">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                }

                <ng-container matColumnDef="fde_serial_uuid">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef
                            [style.min-width]="getColumnWidth('fde_serial_uuid')">
                        {{'assign.fde.columns.workstation-id' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let fdeLicense" id="fde_serial_uuid">
                        @if (isLoading$ | async) {
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '16px' }"></ngx-skeleton-loader>
                        } @else {
                            {{ fdeLicense.fde_serial_uuid }}
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="created_dttm">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef
                            [style.min-width]="getColumnWidth('created_dttm')">
                        {{'assign.fde.columns.created' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let fdeLicense" id="created_dttm">
                        @if (isLoading$ | async) {
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '16px' }"></ngx-skeleton-loader>
                        } @else {
                            {{ fdeLicense.created_dttm | date:'medium' }}
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="last_generated">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef
                            [style.min-width]="getColumnWidth('last_generated')">
                        {{'assign.fde.columns.last-generated' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let fdeLicense" id="last_generated">
                        @if (isLoading$ | async) {
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '16px' }"></ngx-skeleton-loader>
                        } @else {
                            {{ fdeLicense.last_generated | date:'medium' }}
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="fde_license_id">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef
                            [style.min-width]="getColumnWidth('fde_license_id')">
                        {{'assign.fde.columns.license-id' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let fdeLicense" id="fde_license_id">
                        @if (isLoading$ | async) {
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '16px' }"></ngx-skeleton-loader>
                        } @else {
                            {{ fdeLicense.fde_license_id }}
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="maint_exp_timestamp">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef
                            [style.min-width]="getColumnWidth('maint_exp_timestamp')">
                        {{'assign.columns.maintenance-date' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let fdeLicense">
                        @if (isLoading$ | async) {
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '16px' }"></ngx-skeleton-loader>
                        } @else {
                            {{ fdeLicense.maint_exp_timestamp | date }}
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="license_key">
                    <th scope="col" mat-header-cell *matHeaderCellDef
                            [style.width]="getColumnWidth('license_key')">
                        {{'assign.fde.license-key' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let fdeLicense" id="fdeLicense.license-text" class="license-key-button-group">
                        @if (fdeLicense.fde_license_id) {
                            <span class="mdi mdi-tray-arrow-down icon clickable"
                                  matTooltip="{{'assign.fde.download_response_code_tooltip' | translate}}"
                                  matTooltipPosition="below"
                                  (click)="create_download_file(fdeLicense)">
                            </span>
                            <span id="copyResponseCodeButton"
                                  class="mdi mdi-content-copy icon clickable"
                                  matTooltip="{{'assign.fde.copy_response_code_tooltip' | translate}}"
                                  matTooltipPosition="below" (click)="onCopyResponseCode(fdeLicense)">
                            </span>
                            <span id="detailsButton"
                                  class="mdi mdi-text-box-search-outline icon clickable"
                                  matTooltip="{{'assign.details.tool-tip' | translate}}"
                                  matTooltipPosition="below"
                                  (click)="showDetailsDialog(fdeLicense.fde_serial_uuid)">
                            </span>
                        }
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let fdeLicense; columns: columnsToDisplay"></tr>
            </table>
            @if ((isLoading$ | async) === false && (licenses$ | async)?.length === 0) {
                <div class="paging-span" id="nodata">
                    <span class="no-licenses">{{ 'assign.fde.no-fde-licenses-found' | translate }}</span>
                </div>
            }
        </div>
    </div>
</div>
